/**
 * Chat Orchestrator
 * Platform-agnostic chat execution — extracted from useChatWithSteps hook.
 * Used by both web (via hook wrapper) and CLI (directly).
 */

export async function executeChat(
  content: string,
  {
    chatEngine,
    api,
    conversationId,
    host,
    participants,
    messages,
    onStep,
    save = async (msg: any) => api.saveMessages(conversationId, [msg]),
  }: any,
) {
  await chatEngine.handleUserMessage(content, {
    host,
    participants,
    messages,
    save,
    onStep,
  })
}
